import { Box, Heading, Flex, Divider } from '@chakra-ui/react'
import { isBlank } from '@!/Util'
import { useRanking } from '@!/Hooks'
import { TagItem } from '@!/Store/Home/components'
import { useTabs } from '@!/Store/Ranking/hooks/useTabs'
import RankingTitleList from '@!/Store/Ranking/components/RankingTitleList'

const Ranking = ({ tabName }) => {
  const { currentTab, tabs, handleTabChange } = useTabs(tabName)
  const isActive = (index) => index === currentTab.index
  const currentPage = 1
  const perPage = tabName ? 10 : 100
  const { data: rankingTitles } = useRanking(currentTab.name, currentPage, perPage)

  return (
    <Box px={4} py={6}>
      <Heading as="h1" fontSize="md" mb={4}>
        デイリー人気ランキング
      </Heading>
      <Flex flexWrap="wrap" gap={1}>
        {tabs.map((tab, index) => (
          <Box key={tab.name}>
            <TagItem
              name={tab.label}
              as="a"
              whiteSpace="nowrap"
              bg={isActive(index) && 'label.primary'}
              color={isActive(index) && 'label.white'}
              fontSize="xs"
              px={3}
              cursor="pointer"
              onClick={() => {
                handleTabChange(index)
              }}
            />
          </Box>
        ))}
      </Flex>
      <Divider my={4} />
      {!isBlank(rankingTitles) && <RankingTitleList rankingTitles={rankingTitles} currentTab={currentTab} />}
    </Box>
  )
}

export default Ranking
